import React, { useState } from "react";
import { toast } from "sonner";
import { Phone, MessageCircle, Instagram, Send } from "lucide-react";
import { Button } from "../ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";
import { Input } from "../ui/input";
import { Textarea } from "../ui/textarea";
import { PHONE_TEL } from "@/mock";
import api from "@/shared/api";

export const CTASection = () => {
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [message, setMessage] = useState("");

    const sendQuickMessage = async (e) => {
        e.preventDefault();

        if (!name || !email || !message) {
            toast.error("Заполните все обязательные поля!")
        }

        try {
            const res = await api.post('/api/booking/quick-message', {
                name,
                email,
                message,
            })

            if (res.status === 200) {
                toast.success("Сообщение отправлено!")
            }
        } catch (error) {
            console.error(error);
            toast.error("Упс, ошибка сервера!");
        }
    }

    return (
        <section id="contacts" className="py-16 relative overflow-hidden">
            <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 grid md:grid-cols-3 gap-8 items-center">
                <div className="md:col-span-2">
                    <h2 className="font-serif text-3xl text-olive-950">Обсудим ваш запрос?</h2>
                    <p className="mt-2 text-olive-900/70 text-sm">Звонок — самый быстрый способ договориться о встрече.</p>
                    <div className="mt-4 flex flex-wrap gap-3">

                        <Button
                            asChild
                            variant="outline"
                            className="text-primary hover:bg-primary/10 border border-primary/20 hover:border-transparent hover:text-primary"
                        >
                            <a href="https://t.me/bondarevapro" target="_blank" rel="noopener noreferrer">
                                <Send className="w-4 h-4" />
                            </a>
                        </Button>

                        <Button
                            asChild
                            variant="outline"
                            className="text-primary hover:bg-primary/10 border border-primary/20 hover:border-transparent hover:text-primary"
                        >
                            <a href={PHONE_TEL}>
                                <Phone className="w-4 h-4" />
                            </a>
                        </Button>

                        <Button
                            asChild
                            variant="outline"
                            className="text-primary hover:bg-primary/10 border border-primary/20 hover:border-transparent hover:text-primary"
                        >
                            <a href="https://www.instagram.com/bondareva.pro/" target="_blank" rel="noopener noreferrer">
                                <Instagram className="w-4 h-4" />
                            </a>
                        </Button>
                    </div>
                </div>

                <Card className="bg-white/70 backdrop-blur-xl border-olive-100">
                    <CardHeader>
                        <CardTitle className="text-olive-950">Быстрое сообщение</CardTitle>
                    </CardHeader>
                    <CardContent>
                        <form onSubmit={sendQuickMessage} className="space-y-3">
                            <Input placeholder="Имя" required value={name} onChange={(e) => setName(e.target.value)} />
                            <Input type="email" placeholder="Email" required value={email} onChange={(e) => setEmail(e.target.value)} />
                            <Textarea placeholder="Ваше сообщение" rows={4} required value={message} onChange={(e) => setMessage(e.target.value)} />
                            <Button type="submit" className="w-full bg-olive-800 hover:bg-olive-900 text-olive-50">
                                <MessageCircle className="w-4 h-4 mr-2" /> Отправить
                            </Button>
                        </form>
                    </CardContent>
                </Card>
            </div>
        </section>
    );
};
